import { render } from "./PageComponent.vue?vue&type=template&id=7994a49f"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Page/PageComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7994a49f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7994a49f', __exports__)) {
    api.reload('7994a49f', __exports__)
  }
  
  module.hot.accept("./PageComponent.vue?vue&type=template&id=7994a49f", () => {
    api.rerender('7994a49f', render)
  })

}


export default __exports__